// extracted by mini-css-extract-plugin
module.exports = {"grid":"Grid_grid__2bG1s","card":"Grid_card__rLSq7"};